'use client';

import {ActivityService} from '@services/activity/activity.service';
import {usePathname, useSearchParams} from 'next/navigation';
import {FC, useEffect, useRef} from 'react';

const PageViewTracker: FC = () => {
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const prevPathname = useRef<string | null>(null);

    useEffect(() => {
        if (prevPathname.current === pathname) {
            return;
        }
        prevPathname.current = pathname;

        const callback = () => {
            // deferring tracking is nice but not necessary
            ActivityService.logPageView(pathname, searchParams);
        };

        if ('requestIdleCallback' in window) {
            const idleCallback = requestIdleCallback(callback);
            return () => cancelIdleCallback(idleCallback);
        } else {
            // safari
            const timeout = setTimeout(callback, 100);
            return () => clearTimeout(timeout);
        }
    }, [pathname, searchParams]);

    return null;
};

export default PageViewTracker;
